import React, { Component } from "react";
import { losingData, winningData } from "./../game-data";
import PropTypes from "prop-types";
import Header from "./Header";

export default class Over extends Component {
  render() {
    const { progress, dictionary, question, answer, game, click } = this.props;
    let overData = {};
    if (game.lose) {
      overData.img = losingData[game.overIndex].img;
      overData.text = dictionary[`loser_${game.overIndex + 1}`];
      if (game.adText) {
        overData.adText =
          dictionary[
            `result_${question.current}_${answer.option + 1}_${
              answer.result + 1
            }`
          ];
      }
      overData.icon = "bad";
    } else if (game.win) {
      overData.img = winningData[game.overIndex].img;
      overData.text = dictionary[`winner_${game.overIndex + 1}`];
      overData.icon = "good";
    }

    return (
      <div className="own-it__over">
        <Header icon={overData.icon} />
        <div className="over__top">
          <div className="over__left">
            <div className="over__img">
              <img src={overData.img} alt="" />
            </div>
          </div>
          <div className="over__right">{progress}</div>
        </div>
        <div className="over__bottom">
          {overData.adText && (
            <div className="over__ad-text">
              <p>{overData.adText}</p>
            </div>
          )}
          <div
            className="over__text"
            dangerouslySetInnerHTML={{
              __html: overData.text,
            }}
          />
          <div className="over__more">
            <button className="answer__next-btn" onClick={() => click()}>
              {dictionary.link_more}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

Over.propTypes = {
  dictionary: PropTypes.object,
  answer: PropTypes.object,
  question: PropTypes.object,
  game: PropTypes.object,
  click: PropTypes.func,
};
